import React from 'react'
import { Box, Typography, Pill } from 'components'
import { makeStyles, Chip } from '@material-ui/core'
import { useHistory } from 'react-router-dom'

const useStyles = makeStyles(theme => ({
  selfIdChip: {
    margin: theme.spacing(0.5),
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    '& .MuiChip-label': {
      fontSize: '0.85rem',
      fontWeight: 400
    }
  },
  sectionContainer: {
    backgroundColor: 'white',
    border: '1px solid #DDD',
    borderRadius: 10,
    marginBottom: theme.spacing(3)
  }
}))

export default function FreelancerSelfIdSection({ freelancer, onEdit: propOnEdit }) {
  const classes = useStyles()
  const history = useHistory()


  // If onEdit is provided as a prop, use it. Otherwise, redirect to ethnicity edit route
  const onEdit = propOnEdit

  // Only render if there are self-identification tags
  if ((!freelancer.selfIdentificationTags || freelancer.selfIdentificationTags.length === 0) && !onEdit) {
    return null
  }

  return (
    <Box className={classes.sectionContainer}>
      <Box flex={1} pt={3.5} px={3.5} pb={2}>
        <Box flex={1} flexVariant="row space-between" mb={2.5}>
          <Typography variant="h4" style={{ fontWeight: '600' }}>
            Ethnicity
          </Typography>
          {onEdit &&
            <Pill size="small" onClick={onEdit}>
              Manage Tags
            </Pill>}
        </Box>

        <Box display="flex" flexWrap="wrap" mb={2}>
          {freelancer.selfIdentificationTags ? freelancer.selfIdentificationTags.map((tag, index) => (
            <Chip
              key={index}
              label={tag}
              className={classes.selfIdChip}
            />
          )) : ''}
        </Box>
      </Box>
    </Box>
  )
}
